
const AppConfig = {
    brandName: "LVMH",
    // Add other config variables here if needed
  };
  
  export default AppConfig;
  